export const AllEligibleType = [
    { value: "eligible", label: "Elegível" },
    { value: "notEligible", label: "Não Elegível" },
    { value: "maybe", label: "Talvez" },
    { value: "pendant", label: "Pendente" }
];